import React from 'react';
import { useSelector } from 'react-redux';

export default function Avatar(props) {
    const fallbackAvatarUrl = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png';

    const { avatar_url = fallbackAvatarUrl } = useSelector((state) => state.auth);
    const { width, height, extraStyles } = props;

    if (!width || !height) {
        console.log('Avatar components require a width prop and a height prop');
    }

    return (
        <div
            className={`avatar ${width} ${height} ${extraStyles} bg-pink-avatar rounded-full min-${width}`}
        >
            <img src={fallbackAvatarUrl} alt="Avatar" className={'rounded-full'} />
        </div>
    );
}

